import gql from 'graphql-tag';

export default gql`
  fragment S3Object on S3Object {
    bucket
    key
    width
    height
    region
  }
`;
